import { getUrl } from 'aws-amplify/storage';
import { env, isValidURL } from './utils';

const readAWSS3File = async (folder: string, fileURL?: string): Promise<any> => {
  try {
    if (!fileURL || !isValidURL(fileURL)) {
      return fileURL;
    }

    const bucketName = env('RIVER_AWS_BUCKET_NAME') || '';

    if (bucketName && fileURL.includes(bucketName)) {
      const fileURLObj = new URL(fileURL);
      fileURLObj.search = '';
      const pathParts = fileURLObj.pathname.split(`/${folder}/`);

      if (pathParts[1]) {
        const getFileKey = decodeURIComponent(pathParts[1]);
        const { url } = await getUrl({ path: `public/${folder}/${getFileKey}` });

        return url.toString();
      }

      const fallbackKey = decodeURIComponent(
        fileURLObj.pathname.replace(/^\/(public|private|protected)\//, '').replace(/^\/+/, ''),
      );
      const { url } = await getUrl({ path: `public/${fallbackKey}` });

      return url.toString();
    }

    return fileURL;
  } catch (error) {
    console.error('Could not read file errors', error);
    return fileURL || '';
  }
};

export default readAWSS3File;
